import { Component } from 'react';
import { connect } from 'react-redux';

import ListItem from './ListItem';
import SocialLinks from '../SocialLinks';

import menuData from './menu_data';

import './styles/footer.scss';
import {linkWithUtm} from "../../helpers/linkWithUtm";

const MAX_MOBILE_WIDTH = 550;

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileStatus: false,
      subscribeStatus: 'start'
    };
  }

  componentDidMount() {
    // check width for changed styles
    if (window.innerWidth < MAX_MOBILE_WIDTH) {
      this.setState({
        mobileStatus: true
      });
    }

    window.addEventListener('resize', this.updateListOfMenu.bind(this));
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  updateListOfMenu() {
    this.setState({
      mobileStatus: window.innerWidth < MAX_MOBILE_WIDTH
    });
  }

  render() {
    return (
      <div className="footer">
        <div className="footer__line">
          <img src={require('../../static/images/logo-line.svg').default} alt="" />
          <img src={require('../../static/images/logo-line.svg').default} alt="" />
        </div>
        <div className="footer__up">
          <div className="container">
            {menuData &&
              menuData.map((el) => {
                el.list.map(subEl => subEl.link = (subEl.type == 'document' && this.props.documents?.[subEl.link]?.url) ? this.props.documents?.[subEl.link]?.url : subEl.link);
                return <ListItem key={el.id} submenu={el} mobileStatus={this.state.mobileStatus} />
              })}
            <div className="footer__up__item" key="5">
              <div className="footer__up__connector">
                <div className="footer__up__social">
                  <span>Следите за нами в соц. сетях</span>
                  <SocialLinks />
                </div>
                <div className="footer__up__stores">
                  <ul>
                    <li>
                      <img src={require('../../static/images/common/paykeeper.svg').default} alt="paykeeper" />
                    </li>
                    <li>
                      <img src={require('../../static/images/common/visa.svg').default} alt="visa" />
                    </li>
                    <li>
                      <img src={require('../../static/images/common/mastercard.svg').default} alt="mastercard" />
                    </li>
                    <li>
                      <img src={require('../../static/images/common/mir.svg').default} alt="mir" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__down">
          <div className="container">
            <div className="footer__down__links">
              <ul>
                <li>
                  <a href={linkWithUtm('https://fitron.club/policy/')} target="_blank" rel="nofollow noopener">
                    Политика обработки персональных данных
                  </a>
                </li>
                <li>
                  <a href={this.props.documents?.['politics_cookie.pdf']?.url} target="_blank" rel="nofollow noopener">
                    Политика использования файлов cookie
                  </a>
                </li>
                <li>
                  <a href={this.props.documents?.['user-agreement.pdf']?.url} target="_blank" rel="nofollow noopener">
                    Пользовательское соглашение
                  </a>
                </li>
                {/* <li>
                  <a href="/franchise/" target="_blank" rel="nofollow noopener">
                    Франчайзинг
                  </a>
                </li> */}
                <li>
                  <a href="https://fitron.club/legal-documents/" target="_blank" rel="nofollow noopener">
                    Правовые документы
                  </a>
                </li>
                <li>
                  <a href="https://fitron.club/sitemap/" target="_blank" rel="nofollow noopener">
                    Карта сайта
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer__down__copyright">
            <div className="container">
              <span
                  dangerouslySetInnerHTML={{ __html: `&copy;&nbsp;2016&nbsp;&mdash; ${new Date().getFullYear()} Фитнес-клуб Fitron, ИП Плужников М. А., юридический адрес: 344013, Ростовская обл, Ростов-на-Дону г, Мечникова ул, дом 24а
                  <a href="tel:+78633018000" class="phone-link">8 (863) 301 8000</a>` }}
              />
            </div>
          </div>
        </div>
        <button className="footer__goToUp" onClick={this.scrollToTop.bind(this)}>
          <img src={require('../../static/images/icons/arrow-top.svg').default} alt="arrrow-top" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { referer, documents } = state;

  return {
    ...referer,
    ...documents
  };
};

export default connect(mapStateToProps, null)(Footer);
